<script setup lang="ts">
</script>

<template>
<div>
  <Header/>
  <slot/>
  <Footer/>
</div>
</template>

<style scoped>
div {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>